/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 性别
 */
let EnumSex = {
	Men             : new EnumItem('男', 1),
    Women              : new EnumItem('女', 2),
	...enumMixn
}
export default EnumSex
